const values = [
  "icon_catalyst_affinity_blue_01",
  "icon_catalyst_affinity_blue_02",
  "icon_catalyst_affinity_blue_03",
  "icon_catalyst_affinity_blue_04",
  "icon_catalyst_affinity_brown_01",
  "icon_catalyst_affinity_brown_02",
  "icon_catalyst_affinity_brown_03",
  "icon_catalyst_affinity_brown_04",
  "icon_catalyst_affinity_gold_01",
  "icon_catalyst_affinity_gold_02",
  "icon_catalyst_affinity_gold_03",
  "icon_catalyst_affinity_gold_04",
  "icon_catalyst_affinity_green_01",
  "icon_catalyst_affinity_green_02",
  "icon_catalyst_affinity_green_03",
  "icon_catalyst_affinity_green_04",
  "icon_catalyst_affinity_purple_01",
  "icon_catalyst_affinity_purple_02",
  "icon_catalyst_affinity_purple_03",
  "icon_catalyst_affinity_purple_04",
  "icon_catalyst_affinity_red_01",
  "icon_catalyst_affinity_red_02",
  "icon_catalyst_affinity_red_03",
  "icon_catalyst_affinity_red_04",
  "icon_catalyst_class_hero_01",
  "icon_catalyst_class_hero_02",
  "icon_catalyst_class_hero_03",
  "icon_catalyst_class_hero_04",
  "icon_catalyst_class_spell_01",
  "icon_catalyst_class_spell_02",
  "icon_catalyst_class_spell_03",
  "icon_catalyst_class_spell_04",
  "icon_catalyst_class_tower_01",
  "icon_catalyst_class_tower_02",
  "icon_catalyst_class_tower_03",
  "icon_catalyst_class_tower_04",
  "icon_catalyst_main_item1_blue_01",
  "icon_catalyst_main_item1_blue_02",
  "icon_catalyst_main_item1_blue_03",
  "icon_catalyst_main_item1_blue_04",
  "icon_catalyst_main_item1_green_01",
  "icon_catalyst_main_item1_green_02",
  "icon_catalyst_main_item1_green_03",
  "icon_catalyst_main_item1_green_04",
  "icon_catalyst_main_item1_orange_01",
  "icon_catalyst_main_item1_orange_02",
  "icon_catalyst_main_item1_orange_03",
  "icon_catalyst_main_item1_orange_04",
  "icon_catalyst_main_item1_pink_01",
  "icon_catalyst_main_item1_pink_02",
  "icon_catalyst_main_item1_pink_03",
  "icon_catalyst_main_item1_pink_04",
  "icon_catalyst_main_item1_purple_01",
  "icon_catalyst_main_item1_purple_02",
  "icon_catalyst_main_item1_purple_03",
  "icon_catalyst_main_item1_purple_04",
  "icon_catalyst_main_item1_violet_01",
  "icon_catalyst_main_item1_violet_02",
  "icon_catalyst_main_item1_violet_03",
  "icon_catalyst_main_item1_violet_04",
  "icon_catalyst_main_item2_blue_01",
  "icon_catalyst_main_item2_blue_02",
  "icon_catalyst_main_item2_blue_03",
  "icon_catalyst_main_item2_blue_04",
  "icon_catalyst_main_item2_green_01",
  "icon_catalyst_main_item2_green_02",
  "icon_catalyst_main_item2_green_03",
  "icon_catalyst_main_item2_green_04",
  "icon_catalyst_main_item2_orange_01",
  "icon_catalyst_main_item2_orange_02",
  "icon_catalyst_main_item2_orange_03",
  "icon_catalyst_main_item2_orange_04",
  "icon_catalyst_main_item2_pink_01",
  "icon_catalyst_main_item2_pink_02",
  "icon_catalyst_main_item2_pink_03",
  "icon_catalyst_main_item2_pink_04",
  "icon_catalyst_main_item2_purple_01",
  "icon_catalyst_main_item2_purple_02",
  "icon_catalyst_main_item2_purple_03",
  "icon_catalyst_main_item2_purple_04",
  "icon_catalyst_main_item2_violet_01",
  "icon_catalyst_main_item2_violet_02",
  "icon_catalyst_main_item2_violet_03",
  "icon_catalyst_main_item2_violet_04",
  "icon_catalyst_main_item3_blue_01",
  "icon_catalyst_main_item3_blue_02",
  "icon_catalyst_main_item3_blue_03",
  "icon_catalyst_main_item3_blue_04",
  "icon_catalyst_main_item3_green_01",
  "icon_catalyst_main_item3_green_02",
  "icon_catalyst_main_item3_green_03",
  "icon_catalyst_main_item3_green_04",
  "icon_catalyst_main_item3_orange_01",
  "icon_catalyst_main_item3_orange_02",
  "icon_catalyst_main_item3_orange_03",
  "icon_catalyst_main_item3_orange_04",
  "icon_catalyst_main_item3_pink_01",
  "icon_catalyst_main_item3_pink_02",
  "icon_catalyst_main_item3_pink_03",
  "icon_catalyst_main_item3_pink_04",
  "icon_catalyst_main_item3_purple_01",
  "icon_catalyst_main_item3_purple_02",
  "icon_catalyst_main_item3_purple_03",
  "icon_catalyst_main_item3_purple_04",
  "icon_catalyst_main_item3_violet_01",
  "icon_catalyst_main_item3_violet_02",
  "icon_catalyst_main_item3_violet_03",
  "icon_catalyst_main_item3_violet_04",
  "icon_catalyst_main_item4_blue_01",
  "icon_catalyst_main_item4_blue_02",
  "icon_catalyst_main_item4_blue_03",
  "icon_catalyst_main_item4_blue_04",
  "icon_catalyst_main_item4_green_01",
  "icon_catalyst_main_item4_green_02",
  "icon_catalyst_main_item4_green_03",
  "icon_catalyst_main_item4_green_04",
  "icon_catalyst_main_item4_orange_01",
  "icon_catalyst_main_item4_orange_02",
  "icon_catalyst_main_item4_orange_03",
  "icon_catalyst_main_item4_orange_04",
  "icon_catalyst_main_item4_pink_01",
  "icon_catalyst_main_item4_pink_02",
  "icon_catalyst_main_item4_pink_03",
  "icon_catalyst_main_item4_pink_04",
  "icon_catalyst_main_item4_purple_01",
  "icon_catalyst_main_item4_purple_02",
  "icon_catalyst_main_item4_purple_03",
  "icon_catalyst_main_item4_purple_04",
  "icon_catalyst_main_item4_violet_01",
  "icon_catalyst_main_item4_violet_02",
  "icon_catalyst_main_item4_violet_03",
  "icon_catalyst_main_item4_violet_04",
  "icon_catalyst_main_item5_blue_01",
  "icon_catalyst_main_item5_blue_02",
  "icon_catalyst_main_item5_blue_03",
  "icon_catalyst_main_item5_blue_04",
  "icon_catalyst_main_item5_green_01",
  "icon_catalyst_main_item5_green_02",
  "icon_catalyst_main_item5_green_03",
  "icon_catalyst_main_item5_green_04",
  "icon_catalyst_main_item5_orange_01",
  "icon_catalyst_main_item5_orange_02",
  "icon_catalyst_main_item5_orange_03",
  "icon_catalyst_main_item5_orange_04",
  "icon_catalyst_main_item5_pink_01",
  "icon_catalyst_main_item5_pink_02",
  "icon_catalyst_main_item5_pink_03",
  "icon_catalyst_main_item5_pink_04",
  "icon_catalyst_main_item5_purple_01",
  "icon_catalyst_main_item5_purple_02",
  "icon_catalyst_main_item5_purple_03",
  "icon_catalyst_main_item5_purple_04",
  "icon_catalyst_main_item5_violet_01",
  "icon_catalyst_main_item5_violet_02",
  "icon_catalyst_main_item5_violet_03",
  "icon_catalyst_main_item5_violet_04",
  "icon_catalyst_main_item6_blue_01",
  "icon_catalyst_main_item6_blue_02",
  "icon_catalyst_main_item6_blue_03",
  "icon_catalyst_main_item6_blue_04",
  "icon_catalyst_main_item6_green_01",
  "icon_catalyst_main_item6_green_02",
  "icon_catalyst_main_item6_green_03",
  "icon_catalyst_main_item6_green_04",
  "icon_catalyst_main_item6_orange_01",
  "icon_catalyst_main_item6_orange_02",
  "icon_catalyst_main_item6_orange_03",
  "icon_catalyst_main_item6_orange_04",
  "icon_catalyst_main_item6_pink_01",
  "icon_catalyst_main_item6_pink_02",
  "icon_catalyst_main_item6_pink_03",
  "icon_catalyst_main_item6_pink_04",
  "icon_catalyst_main_item6_purple_01",
  "icon_catalyst_main_item6_purple_02",
  "icon_catalyst_main_item6_purple_03",
  "icon_catalyst_main_item6_purple_04",
  "icon_catalyst_main_item6_violet_01",
  "icon_catalyst_main_item6_violet_02",
  "icon_catalyst_main_item6_violet_03",
  "icon_catalyst_main_item6_violet_04",
  "icon_catalyst_main_item7_blue_01",
  "icon_catalyst_main_item7_blue_02",
  "icon_catalyst_main_item7_blue_03",
  "icon_catalyst_main_item7_blue_04",
  "icon_catalyst_main_item7_green_01",
  "icon_catalyst_main_item7_green_02",
  "icon_catalyst_main_item7_green_03",
  "icon_catalyst_main_item7_green_04",
  "icon_catalyst_main_item7_orange_01",
  "icon_catalyst_main_item7_orange_02",
  "icon_catalyst_main_item7_orange_03",
  "icon_catalyst_main_item7_orange_04",
  "icon_catalyst_main_item7_pink_01",
  "icon_catalyst_main_item7_pink_02",
  "icon_catalyst_main_item7_pink_03",
  "icon_catalyst_main_item7_pink_04",
  "icon_catalyst_main_item7_purple_01",
  "icon_catalyst_main_item7_purple_02",
  "icon_catalyst_main_item7_purple_03",
  "icon_catalyst_main_item7_purple_04",
  "icon_catalyst_main_item7_violet_01",
  "icon_catalyst_main_item7_violet_02",
  "icon_catalyst_main_item7_violet_03",
  "icon_catalyst_main_item7_violet_04",
  "icon_consumable_cannon",
  "icon_consumable_freeze_and_mana",
  "icon_consumable_healing_and_charge",
  "icon_consumable_healing_and_charge_outline",
  "icon_consumable_summon_dragon",
  "icon_consumable_summon_harbinger",
  "icon_consumable_tower_boost",
  "icon_spell_shield",
  "icon_easternegg",
  "icon_eastern_pattern1",
  "icon_eastern_pattern2",
  "icon_eastern_pattern3",
  "icon_damage_dealt",
  "icon_event_coop_key",
  "icon_event_dark_key",
  "icon_event_dark_token",
  "icon_event_fire_token",
  "icon_event_friend_key",
  "icon_event_key",
  "icon_event_light_key",
  "icon_event_light_token",
  "icon_event_nature_key",
  "icon_event_nature_token",
  "icon_event_npe_point",
  "icon_event_physical_key",
  "icon_event_physical_token",
  "icon_event_physic_key",
  "icon_event_physic_token",
  "icon_event_token",
  "icon_event_water_key",
  "icon_event_water_token",
  "icon_guild_boss_key",
  "icon_guild_token",
  "icon_premium_token",
  "icon_raid_ticket",
  "icon_skin_token",
  "icon_spell_shield",
  "active_point_big",
  "card_item",
  "card_item_mask",
  "card_market",
  "card_market_mask",
  "icon_item_coin",
  "icon_item_coin_dungeon",
  "icon_item_gem",
  "icon_item_player_xp",
  "icon_skillpoint",
  "icon_skillpoint02",
  "shard_hero_angelwings",
  "shard_hero_avalanche_surfer",
  "shard_hero_bearchief",
  "shard_hero_beemistress",
  "shard_hero_beetlewarrior",
  "shard_hero_centaurarcher",
  "shard_hero_chosen_girl",
  "shard_hero_cloudrabbit",
  "shard_hero_cloudviking",
  "shard_hero_crazy_alchemist",
  "shard_hero_death_knight",
  "shard_hero_dryad",
  "shard_hero_evil_wings",
  "shard_hero_flamegoddess",
  "shard_hero_flame_thrower",
  "shard_hero_foreseer",
  "shard_hero_hercules",
  "shard_hero_last_dragoon",
  "shard_hero_lava_chef",
  "shard_hero_lionking",
  "shard_hero_merfolk_fighter",
  "shard_hero_ram_hammer",
  "shard_hero_random",
  "shard_hero_reaper",
  "shard_hero_ronin",
  "shard_hero_sandscorpion",
  "shard_hero_toad_shaman",
  "shard_hero_tower_smith",
  "shard_hero_traveling_mage",
  "shard_hero_wind_knight",
  "shard_hero_wolfhuntress",
  "shard_hero_yeti",
  "shard_spell_angelic_host",
  "shard_spell_bolster",
  "shard_spell_breathoffire",
  "shard_spell_bubbleblast",
  "shard_spell_castthebones",
  "shard_spell_consecrate",
  "shard_spell_darksummons",
  "shard_spell_desecrate",
  "shard_spell_divinecommand",
  "shard_spell_dynastinae",
  "shard_spell_fireball",
  "shard_spell_fire_trap",
  "shard_spell_focus_fire",
  "shard_spell_frost_trap",
  "shard_spell_fungalbloom",
  "shard_spell_giftofkinahau",
  "shard_spell_greed_cannon",
  "shard_spell_holy_nova",
  "shard_spell_howling_blast",
  "shard_spell_ice_rupture",
  "shard_spell_judgement",
  "shard_spell_lightning_bolt",
  "shard_spell_magmafall",
  "shard_spell_manastorm",
  "shard_spell_mightofyaoga",
  "shard_spell_polybomb",
  "shard_spell_random",
  "shard_spell_salvo",
  "shard_spell_skywindsaga",
  "shard_spell_spikedbarricade",
  "shard_spell_thunder_wave",
  "shard_spell_treants",
  "shard_spell_typhoon",
  "shard_spell_vine_lash",
  "shard_spell_warbots",
  "shard_tower_arcane_tower",
  "shard_tower_arrow",
  "shard_tower_axemantower",
  "shard_tower_barrack",
  "shard_tower_beetletower",
  "shard_tower_bigheadtower",
  "shard_tower_cannon",
  "shard_tower_catapulttower",
  "shard_tower_centaurbarracks",
  "shard_tower_cloudtower",
  "shard_tower_crusader",
  "shard_tower_darkportal",
  "shard_tower_dragoonbarracks",
  "shard_tower_druid",
  "shard_tower_flame_cannon",
  "shard_tower_frost_tower",
  "shard_tower_huntershut",
  "shard_tower_iceman",
  "shard_tower_lavaooze",
  "shard_tower_leviathan",
  "shard_tower_light_house",
  "shard_tower_merman_tower",
  "shard_tower_mummybarracks",
  "shard_tower_oiltower",
  "shard_tower_planttower",
  "shard_tower_potiondealer_tower",
  "shard_tower_random",
  "shard_tower_repeater",
  "shard_tower_scorcher",
  "shard_tower_stoneguard",
  "shard_tower_sunsanctum",
  "shard_tower_tesla",
  "shard_tower_warlocktower",
  "icon_token_awaken01",
  "icon_guild_trophy",
  "icon_mine_key",
  "icon_tournament_key",
  "icon_tournament_token",
  "icon_token_xp_hero_01",
  "icon_token_xp_hero_02",
  "icon_token_xp_hero_03",
  "icon_token_xp_hero_04",
  "icon_token_xp_spell_01",
  "icon_token_xp_spell_02",
  "icon_token_xp_spell_03",
  "icon_token_xp_spell_04",
  "icon_token_xp_tower_01",
  "icon_token_xp_tower_02",
  "icon_token_xp_tower_03",
  "icon_token_xp_tower_04",
];
export default values;
